import React from 'react';
import { Select } from 'antd';
import api from '../../../config/api';
import { useDidMount } from '../../../components/use';
import { message } from '../../../components/biz';
import { generators, network } from '../../../utils';

const { generatorArray } = generators;
const { Option } = Select;
const WarehouseSelect = (props, ref) => {
  const [warehouse, setWarehouse] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const fetch = async () => {
    setLoading(true);
    const response = await network({
      url: api.orderCenter.detail.warehouse,
      method: 'get',
    });
    if (response.success) {
      if (response.data.success) {
        const warehouse = generatorArray(response.data.data);
        setWarehouse(warehouse);
        setLoading(false);
      } else {
        message.error(response.data.message);
      }
    }
  };

  useDidMount(() => fetch());

  return (
    <Select {...props} loading={loading} ref={ref} allowClear>
      {warehouse.map((item, index) => (
        <Option key={index} value={item && item.aamcu}>
          {item && item.mcdl01}
        </Option>
      ))}
    </Select>
  );
};

export default React.forwardRef(WarehouseSelect);
